import { espnTricodes } from '../../utilities/tricodes';

// Build reverse lookup: team name -> tricode
const tricodeByName = Object.entries(espnTricodes).reduce(
  (acc, [code, name]) => {
    acc[name.toUpperCase()] = code;
    return acc;
  },
  {}
);

/**
 * Get team tricode from team name
 * Handles UC system schools and partial matching
 */
export function getTeamTricode(teamName) {
  if (!teamName) return '???';
  const upper = teamName.toUpperCase();

  // Try exact match first
  if (tricodeByName[upper]) return tricodeByName[upper];

  // Handle UC system schools explicitly (common confusion: UCLA vs CAL)
  if (upper.includes('CALIFORNIA') || upper.includes('UC ')) {
    if (upper.includes('LOS ANGELES') || upper.includes('UCLA')) return 'UCLA';
    if (upper.includes('BERKELEY') || upper === 'CAL') return 'CAL';
    if (upper.includes('DAVIS') || upper.includes('UCD')) return 'UCD';
    if (upper.includes('IRVINE') || upper.includes('UCI')) return 'UCI';
    if (upper.includes('SANTA BARBARA') || upper.includes('UCSB'))
      return 'UCSB';
    if (upper.includes('RIVERSIDE') || upper.includes('UCR')) return 'UCRV';
    if (upper.includes('SAN DIEGO') && !upper.includes('STATE')) return 'USD';
    // Generic "California" without campus -> CAL (Berkeley)
    if (
      upper === 'CALIFORNIA' ||
      upper === 'CAL' ||
      upper === 'UC BERKELEY' ||
      upper === 'UNIVERSITY OF CALIFORNIA'
    )
      return 'CAL';
  }

  // Try partial match
  for (const [name, code] of Object.entries(tricodeByName)) {
    if (upper.includes(name) || name.includes(upper)) {
      return code;
    }
  }

  // Fallback: first 3-4 chars of last word
  const words = teamName.split(/\s+/);
  const lastWord = words[words.length - 1];
  return lastWord.substring(0, 4).toUpperCase();
}
